import type { RouteRecordRaw } from 'vue-router'

const collectRoutes: RouteRecordRaw[] = [
  {
    path: 'collect',
    component: () => import('@/views/collect/CollectLayout.vue'),
    redirect: '/collect/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'collect-dashboard',
        component: () => import('@/views/collect/CollectDashboard.vue'),
        meta: { title: '采集中心工作台', permission: 'collect:view' },
      },
      {
        path: 'sources',
        name: 'collect-sources',
        component: () => import('@/views/collect/CollectSources.vue'),
        meta: { title: '数据源管理', permission: 'collect:view' },
      },
      {
        path: 'agents',
        name: 'collect-agents',
        component: () => import('@/views/collect/CollectAgents.vue'),
        meta: { title: 'Agent 管理', permission: 'collect:view' },
      },
      {
        path: 'metrics',
        name: 'collect-metrics',
        component: () => import('@/views/collect/CollectMetrics.vue'),
        meta: { title: '指标管理', permission: 'collect:view' },
      },
    ],
  },
]

export default collectRoutes
